import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function verifyAccess(token) {
  const { data } = await api.get(`/access/verify`, { params: { token } });
  return data;
}

export async function analyzeDecision(payload) {
  const { data } = await api.post(`/decisions/analyze`, payload);
  return data;
}

export async function saveDecision(payload) {
  const { data } = await api.post(`/decisions`, payload);
  return data;
}

export async function listDecisions(params) {
  const { data } = await api.get(`/decisions`, { params });
  return data;
}

export async function getPatterns(member_token) {
  const { data } = await api.get(`/patterns`, { params: { member_token } });
  return data;
}

export async function captureLead(payload) {
  const { data } = await api.post(`/leads`, payload);
  return data;
}

export async function addReflection(decision_id, payload) {
  const { data } = await api.patch(`/decisions/${decision_id}/reflection`, payload);
  return data;
}
